import { useLivekitContext } from "../../VideoProvider/LivekitProvider";

export const useLivekitLeaveRoom = () => {
  const { room } = useLivekitContext();

  return () => room?.disconnect();
};
